const schedulesKeys = {
  listByCalendarWeek: (calendarWeekStart: string, calendarWeekEnd: string) => [
    'schedules',
    calendarWeekStart,
    calendarWeekEnd,
  ],
  selfListByCalendarWeek: (calendarWeekStart: string, calendarWeekEnd: string) => [
    'selfSchedules',
    calendarWeekStart,
    calendarWeekEnd,
  ],
  plannedShiftsByRange: (startDate: string, endDate: string, enterpriseUnitId: string) => [
    'plannedShifts',
    startDate,
    endDate,
    enterpriseUnitId,
  ],
  dayOfWeekStart: ['dayOfWeekStart'],
  workWeekConfigsByJurisdiction: (jurisdictionPath: string) => ['workWeekConfigs', jurisdictionPath],
  actualShiftsByRange: (startDate: string, endDate: string, enterpriseUnitId: string, employeeId?: string) => [
    'actualShifts',
    startDate,
    endDate,
    enterpriseUnitId,
    employeeId,
  ],
  summarySales: (scheduleId: string) => ['schedules', scheduleId, 'sales-summary'],
  summarySalesForWeek: (startDate: string, endDate: string) => ['schedules', 'sales-summary', startDate, endDate],
  preview: (sourceStartDate: string, targetStartDate: string) => [
    'schedules',
    'preview',
    sourceStartDate,
    targetStartDate,
  ],
  weeksRange: (siteId: string) => ['schedules', 'weeksRange', siteId],
  overlappedEmployeeIds: (calendarWeekStart: string, calendarWeekEnd: string) => [
    'schedules',
    'overlappedEmployeeIds',
    calendarWeekStart,
    calendarWeekEnd,
  ],
};

const schedulingKeys = {
  schedules: schedulesKeys,
};

export default schedulingKeys;
